'use client';
import { Button } from '@svenskaspelab/ui/react/button';
import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponToolboxButtonProps = PropsWithChildren<ComponentProps<typeof Button>> & {
  shouldDisplayContainer?: boolean;
  containerClassName?: string;
};

/**
 * Renders a button for the coupontoolbox, should be a direct child to CouponToolboxContent.
 *
 * @param root0 the input object
 * @param root0.children the children to pass down
 * @param root0.type the type of the button, defaults to 'button'
 * @param root0.containerClassName optional className for the container div, only applies if shouldDisplayContainer is true
 * @param root0.shouldDisplayContainer boolean to determine if the button should be wrapped in a styled container, defaults to true
 * @param root0.rest the rest of the props to pass down.
 * @returns button element with correct props set.
 */
export default function CouponToolboxButton({
  children,
  type = 'button',
  containerClassName,
  shouldDisplayContainer = true,
  ...rest
}: CouponToolboxButtonProps): ReactNode {
  const content = (
    <Button {...rest} variant="ghost" className={cn('', rest.className)} type={type}>
      {children}
    </Button>
  );
  return shouldDisplayContainer ? (
    <div
      className={cn(
        'bg-layer-contrast-on-base border-stroke-medium rounded-sm border px-1 py-0.5 lg:px-0 lg:py-0',
        containerClassName
      )}
    >
      {content}
    </div>
  ) : (
    content
  );
}
